// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__X_UVX"};